<template>
  <div class="direct-container signup" v-loading.fullscreen.lock="loading">
    <div class="direct-top">
      <div class="direct-header">
        <div class="header-title">{{getActivityInfo.name}}</div>
        <div class="header-date">
          <span class="hint" style="color:#4F87FB" v-if="getActivityInfo.type == 0 ">打卡活动</span>
          <span class="hint" v-else>报名活动</span>
          <span class="date">{{getActivityInfo.startTime}} ~ {{getActivityInfo.endTime}}</span>
        </div>
      </div>
      <div class="direct-content">
        <div class="content-text" v-html="getActivityInfo.content"></div>
      </div>
    </div>
    <div class="direct-group">
      <div class="group">
        <div class="label">分组</div>
        <div class="value">{{getActivityInfo.groupInfo.groupName || '无'}}</div>
      </div>
      <div class="group number">
        <div class="label">人数</div>
        <div class="value">{{getActivityInfo.groupInfo.maxNum}}</div>
      </div>
    </div>

    <div class="direct-group-person">
      <div class>
        <div class="direct-group">
          <div class="group" style="border:0">
            <div class="label">报名</div>
            <div class="revise-names">
              <span v-for="item in nameArr" :key="item.staffId" class="name">
                <span class="text">{{item.staffName}}</span>
                <span class="icon" @click="detele(item)">
                  <i class="cubeic-wrong"></i>
                </span>
              </span>
            </div>
          </div>
          <div class="limit-nogroup"></div>
        </div>
      </div>
      <div class="sino-welfare-footer">
        <div class="save-btn" @click="enroll">{{enrollText}}</div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { getGroupInfoForSignup, delSignup } from "@/common/api";
import { toast } from "@/common/api/api.js";
export default {
  name: "signupActivity",
  data() {
    return {
      getActivityInfo: {},
      loading: false,
      enrollText: "完成",
      nameArr: [],
      currentBaseInfo : JSON.parse(localStorage.getItem("loginInfo"))
    };
  },
  created() {
    this.getActivityInfoSignup();
  },
  methods: {
    getActivityInfoSignup() {
      this.loading = true;
      getGroupInfoForSignup({
        id: this.$route.query.id,
        officeId: this.currentBaseInfo.unionId,
        groupStatus: this.$route.query.groupStatus,
        groupId: this.$route.query.groupId
      }).then(res => {
        if (res.code == 200) {
          res.data.content = res.data.content
            .replace(new RegExp("&lt;", "g"), "<")
            .replace(new RegExp("&quot;", "g"), "")
            .replace(new RegExp("&gt;", "g"), ">");
          this.getActivityInfo = res.data;
          this.loading = false;
          this.nameArr = res.data.groupInfo.signupStaff;
        }
      });
    },
    enroll() {
      this.$router.go(-1);
    },
    detele(item) {
      this.$createDialog({
        type: "confirm",
        title: "提示",
        icon: "cubeic-alert",
        content: `是否从该活动中删除${item.staffName}?`,
        onConfirm: () => {
          for (var i = 0; i < this.nameArr.length; i++) {
            if (this.nameArr[i].staffId === item.staffId) {
              this.nameArr.splice(i, 1);
            }
          }
          delSignup({
              activityId:this.$route.query.id,
              staffId:item.staffId
          }).then(res=>{
              if(res.code == 200){
                  toast(this,res.message)
              }else{
                  toast(this.res.message,'error')
              }
          })
        }
      }).show();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
.name {
  display: inline-block;
  // width: 33%;
  text-align: center;

  .text {
    color: rgba(136, 136, 136, 1);
    padding-right: 0.3rem;
  }

  .icon {
    i {
      font-size: 16px;
    }
  }
}
</style>